module.exports = require("@angular/router");


//////////////////
// WEBPACK FOOTER
// external "@angular/router"
// module id = 52
// module chunks = 0